import type { BaseRowData } from '@adv-frontend/data-provider';

import { ElementVirtualRows } from './ElementVirtualRows';
import type { VirtualBodyProps } from './VirtualBody.types';
import { WindowKeepMountedVirtualRows } from './WindowKeepMountedVirtualRows';

export type { VirtualBodyCommonProps, VirtualBodyProps } from './VirtualBody.types';

export function VirtualBody<RowData extends BaseRowData>(props: VirtualBodyProps<RowData>) {
    return props.virtualization.verticalVirtualizationMode === 'window-keep-mounted' ? (
        <WindowKeepMountedVirtualRows {...props} />
    ) : (
        <ElementVirtualRows {...props} />
    );
}
